import { Render } from './render'

export const useComponents = {
  install(app: any) {
    app.component('Render', Render)
    return app
  },
}
